<template>
  <div v-if="!loading" class="custom-margin-full-page">


    <div v-if="status === 'invalid'">
      <v-card class="mt-10 pa-16 white--text" color="red lighten-2" elevation="0">
        تراکنش نا معتبر است
      </v-card>
    </div>

    <div v-if="status === 'failed'">
      <v-card class="mt-10 pa-16 white--text" color="red lighten-2" elevation="0">
        تراکنش انجام نشد و مبلغ پرداختی تا ۷۲ ساعت آینده به حساب شما بازخواهد گشت.
        {{ message }}
      </v-card>
    </div>

    <div v-if="status === 'not_found'">
      <v-card class="mt-10 pa-16 white--text" color="red lighten-2" elevation="0">
        تراکنش با شناسه
        <strong> {{ transactionId }} </strong>
        یافت نشد.
      </v-card>
    </div>

    <div v-if="status === 'waiting'">
      <v-card class="mt-10 pa-16 white--text" color="red lighten-2" elevation="0">
        تراکنش با شناسه
        <strong> {{ transactionId }} </strong>
        هنوز در حال محاسبه هست - در صورتی که پرداخت شما ثبت نشود تا حد اکثر ۷۲ ساعت آینده مبلغ {{ amount }}
        تومان به حساب شما واریز خواهد شد.
      </v-card>
    </div>

    <div v-if="status === 'success'">
      <v-card class="mt-10 pa-16 white--text" color="green lighten-2" elevation="0">
        تراکنش با کد رهگیری
        <strong> {{ refId }} </strong>
        با موفقیت انجام شد
        <br>
        <span v-if="transaction.course_id && transaction.subscription_id">
          اشتراک با موفقیت خریداری شد.
        </span>
        <span v-else>
  و مبلغ {{ amount }}
        تومان به کیف پول شما اضافه شد.
        </span>
      </v-card>
    </div>
    <!--    <v-dialog v-model="showSubscriptionDialog" max-width="100vw">-->
    <!--      <v-card class="pa-1 ma-0" style="overflow: hidden!important;">-->
    <!--        <v-row class="ma-0 pa-0" style="overflow: hidden!important;">-->
    <!--          <v-col>-->
    <!--            پرداخت شما برای خرید اشتراک موفقیت آمیز بود.-->
    <!--            <br>-->
    <!--            پرداخت نهایی شود ؟-->
    <!--            <br>-->
    <!--            در صورت انصراف مبلغ پرداختی به کیف پول شما اضافه خواهد شد.-->
    <!--          </v-col>-->
    <!--        </v-row>-->
    <!--        <v-row class="mt-16">-->
    <!--          <v-col cols="6" class="text-center">-->
    <!--            <v-btn color="success" style="letter-spacing: normal!important;" @click="buySubscription()">-->
    <!--              بله-->
    <!--            </v-btn>-->
    <!--          </v-col>-->
    <!--          <v-col cols="6" class="text-center">-->
    <!--            <v-btn color="error" style="letter-spacing: normal!important;" @click="showSubscriptionDialog = false">-->
    <!--              انصراف-->
    <!--            </v-btn>-->
    <!--          </v-col>-->
    <!--        </v-row>-->

    <!--      </v-card>-->
    <!--    </v-dialog>-->
  </div>
</template>

<script>

export default {
  name: "WalletCallBackMobile",
  data() {
    return {
      loading: true,
      status: null,
      refId: null,
      transactionId: null,
      amount: null,
      transaction: null,
      message: null,
      section: null,
      subscription_id: null,
      showSubscriptionDialog: false
    }
  },
  mounted() {
    this.status = this.$route.query.status
    this.transactionId = this.$route.query.transaction_id
    this.refId = this.$route.query.ref_id
    this.message = this.$route.query.message ?? null
    this.section = this.$route.query.section ?? null
    this.subscription_id = this.$route.query.subscription_id ?? null
    this.checkTransaction()
  },
  methods: {
    checkTransaction() {
      window.axios.get('finance/check?transaction_id=' + this.transactionId).then((res) => {
        this.loading = false
        this.transaction = res.data.data
        this.status = this.transaction.status
        this.amount = this.transaction.amount
        // if (this.transaction.section === 'subscription') {
        //   this.showSubscriptionDialog = true
        // }
      }).catch((err) => {
        this.loading = false
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.status = 'not_found'
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    // buySubscription() {
    //   window.axios.post('student/subscriptions/buy', {
    //     subscription_id: this.transaction.subscription_id
    //   }).then((res) => {
    //     if (res.data.data.status) {
    //       this.$router.push('/dashboard')
    //     }
    //   })
    // }
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 0 10vw 0 10vw;
}

.normal-button {
  letter-spacing: normal;
  color: white;
}
</style>